import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { MachineGroupModel } from 'src/app/models/machines/machine-group';
import { OfflineDataService } from 'src/packages/mitsBasics';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class MachineGroupService extends OfflineDataService<MachineGroupModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Machines::MachineGroup',
      http,
      errorService,
      events,
      'machines/machine_groups/',
      'machine_group',
      ['created_at', 'updated_at', 'created_by_id'],
      []
    );
  }
}
